import { Component } from 'react';
import './About.css'
import axios from 'axios';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loading from '../Loading/Loading';
import HTMLReactParser from 'html-react-parser';

function titlee() {
  return document.getElementById('titlee');
}

let title = titlee();

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      line1: 'About Me !!',
      textAnimationLine1: [],
      AboutPageUrl: 'https://my-webpage-node.vercel.app/About/',
      AboutPageData: [],
      loading: false,
      AboutPageKnowledge: [{
        Knowledge: 'HTML',
        icon: '<i style="color:red" class="fab fa-html5 imageDivIcon"></i>'
      }, {
        Knowledge: 'CSS',
        icon: '<i style="color:blue" class="fab fa-css3-alt imageDivIcon"></i>'
      }, {
        Knowledge: 'Javascript',
        icon: '<i style="color:yellow" class="fab fa-js-square imageDivIcon"></i>'
      }, {
        Knowledge: 'React JS',
        icon: '<i style="color:lightskyblue" class="fab fa-react imageDivIcon"></i>'
      }, {
        Knowledge: 'Node JS',
        icon: '<i style="color:greenyellow" class="fab fa-node imageDivIcon"></i>'
      }, {
        Knowledge: 'Mongo DB & SQL',
        icon: '<i style="color:lightslategrey" class="fas fa-database imageDivIcon"></i>'
      }]
    }
  }
  async componentDidMount() {
    title.innerHTML = 'About'
    let tempArr1 = []
    if (this.state.textAnimationLine1.length !== 40) {
      for (let i = 0; i < 40; i++) {
        tempArr1[i] = { letterAni: 0 }
      }
    }
    this.setState({
      textAnimationLine1: tempArr1,
    })
    let HomePage = {
      SelectedPage: 1
    }
    this.props.SelectedPage('SelectedPage', HomePage)
    var countDownAni = 0;
    setInterval(() => {
      if ((countDownAni) < 40 && this.state.loading && this.props.AboutPageProps.AboutPage.Loading) {
        let arr1 = this.state.textAnimationLine1;
        if (countDownAni === 0) {
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        } else {
          arr1[countDownAni - 1] = { letterAni: 2 }
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        }
      }
    }, 100);
    try {
      let Data = await axios.get(this.state.AboutPageUrl);
      this.setState({
        AboutPageData: Data.data,
        loading: true
      })
    } catch (err) {
      console.log(err)
    }
  }

  render() {
    return (<>
      {this.state.loading && this.props.AboutPageProps.AboutPage.Loading ?
        <>
          <div className='mainDivAboutPage'>
            <div className='TextDivisionAbout'>
              <div className='AboutHeadingDiv'>
                {this.state.line1.split('').map((ite, index) => {
                  return (<>{ite === ' ' ? <span className='AboutAniLetterSpace'>{ite}</span> : <span onMouseEnter={() => {
                    let ani = this.state.textAnimationLine1
                    ani[index] = { letterAni: 1 }
                    this.setState({
                      textAnimationLine1: ani
                    })
                  }} onMouseLeave={() => {
                    setTimeout(() => {
                      let ani = this.state.textAnimationLine1
                      ani[index] = { letterAni: 2 }
                      this.setState({
                        textAnimationLine1: ani
                      })
                    }, 500)
                  }} className={this.state.textAnimationLine1[index]?.letterAni === 0 || undefined || null ? 'AboutAniLtr' : this.state.textAnimationLine1[index]?.letterAni === 1 ? 'AboutAniLetterMouse AboutAniLetter' : 'AboutAniLetter'}>{ite}</span>}
                  </>)
                })}
              </div>
              <div className='detailedDescriptnAbout'>
                <div className='DescpPara'>
                  {this.state.AboutPageData?.map((ite, index) => {
                    return (<>
                      <p className='DescpPara'>{ite.about}</p>
                    </>)
                  })}
                </div>
                <div className='DescpLink'>
                  <div className='AboutLink1' onClick={() => {
                    this.props.history.push('/Skills')
                    let HomePage = {
                      SelectedPage: 2
                    }
                    this.props.SelectedPage('SelectedPage', HomePage)
                  }}>See My Skills</div>
                </div>
              </div>
            </div>
            <div className='imageDivisionAbout'>
              <div className='imageInnerDivAbout'>
                {this.state.loading ? this.state.AboutPageKnowledge?.length ?
                  this.state.AboutPageKnowledge.map((ite, index) => {
                    return (<>
                      <div className='ImageDivSep'>
                        <div className={`AboutKnowledge`}>{ite?.Knowledge}</div>
                        <div>{HTMLReactParser(ite.icon)}</div>
                      </div>
                    </>)
                  })
                  : '' : ''}
              </div>
            </div>
          </div>
          {/* <div style={{height:'100vh'}}>

                    </div> */}
        </> : <Loading />}
    </>);
  }
}

const mapStateToProps = (state) => ({
  AboutPageProps: state.Reducer
})

const mapDispatchToProps = (dispatch) => ({
  SelectedPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  }),
  LoadingPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  })
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(About));